import Swiper from 'swiper';

const Sliders = () => {

    var swiper = new Swiper(".application-slider-js", {
        slidesPerView: 'auto',
        initialSlide: 5,
        effect: 'coverflow',
        loop: true,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            modifier: 1,
            slideShadows: false,
            depth: 350
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    // Animals slider

    const animalsSlider = new Swiper('.animals-slider-js', {
        effect: 'fade',
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
        },
    });

    // Home slider

    const homeSlider = new Swiper('.slider-home', {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 8000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
    });

    // Custom reviews slider

    const reviewsSlider = new Swiper('.custom-reviews-js', {
        speed: 400,
        spaceBetween: 15,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            // when window width is >= 575px
            575: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            // when window width is >= 960px
            960: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }
    });

    var personaSwiper = new Swiper(".persona-slider__container", {
        slidesPerView: 'auto',
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });
    var personaSecondSwiper = new Swiper(".persona-second-slider__container", {
        slidesPerView: 'auto',
        spaceBetween: 15,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });

    var securitySlider = new Swiper(".security__slider-container", {
        slidesPerView: 'auto',
        spaceBetween: 0,
        autoplay: {
            delay: 5000,
        },
    });

    var securityComments = new Swiper(".security__comments-items-js", {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 5000,
        },
        loop: true,
        navigation: {
            nextEl: '.security__comments-navigation-right',
            prevEl: '.security__comments-navigation-left',
            disabledClass: 'security__comments-navigation-disabled',
            hiddenClass: 'security__comments-navigation-hidden'
        },
        breakpoints: {
            575: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 14,
            },
            1024: {
                spaceBetween: 14,
                slidesPerView: 4,
            }
        }
    });

    var securityComments = new Swiper(".security__comments-items-new-js", {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        loop: true,
        breakpoints: {
            575: {
                slidesPerView: 2,
                spaceBetween: 10,
                autoplay: {
                    delay: 5000,
                },
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 14,
            },
            1024: {
                spaceBetween: 14,
                slidesPerView: 3,
            }
        }
    });


    var securityMenuMobileIcons = new Swiper(".security__menu-slider", {
        slidesPerView: 2,
        spaceBetween: 0,
        navigation: {
            nextEl: '.security__menu--mobile-navigation-right',
            prevEl: '.security__menu--mobile-navigation-left',
            disabledClass: 'security__menu--mobile-navigation-disabled',
            hiddenClass: 'security__menu--mobile-navigation-hidden'
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            450: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            575: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
        }
    });

    var swiperPersonaPhones = new Swiper(".persona-phone-slider__container", {
        slidesPerView: 'auto',
        initialSlide: 2,
        effect: 'coverflow',
        loop: true,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            modifier: 1,
            slideShadows: false,
            depth: 350
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });
      
}

export default Sliders;